module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/GxqxIy/tc-custom/9781590209585.jpg?1738478986226",
      "alt": "This image is the cover for the book Hotel Savoy"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Hotel Savoy\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A POW meets other survivors of World War I in a Polish hotel in this acclaimed classic novel by the author of "), _c('i', [_vm._v("The Radetzky March")]), _vm._v(".")]), _c('br'), _c('br'), _vm._v("Still bearing the scars from gulag experiences, a freed POW traverses Russia to arrive at the Polish town of Lodz. In its massive Hotel Savoy, he meets a surreal cast of characters, each eagerly awaiting the return from America of a rich man named Bloomfield. Like Europe itself at the time, the hotel is the stage upon which characters follow fate to its tragic destination . . . "), _c('br'), _c('br'), _c('b', [_vm._v("Praise for "), _c('i', [_vm._v("Hotel Savoy")])]), _c('br'), _c('br'), _c('b', [_vm._v("“Superb Roth: witty, elegant, invariably honing in on the point where history trickles down to the level of the individual character and turns into fate.” —"), _c('i', [_vm._v("The Nation")])]), _c('br'), _c('br'), _c('b', [_vm._v("“Roth’s considerable gift lay in sketching myriad personal convulsions in that time of conflagration.” —"), _c('i', [_vm._v("Publishers Weekly")])])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Joseph Roth\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Joseph Roth was born in 1894 in a small Galician town on the eastern borders of the Hapsburg Empire. After serving in the Austro-Hungarian army from 1916 to 1918, he worked as a journalist in Vienna and in Berlin. He died in Paris in 1939, leaving behind thirteen novels as well as many stories and essays.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The Overlook Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0